import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-flower-name-sample',
  templateUrl: './flower-name-sample.component.html',
  styleUrls: ['./flower-name-sample.component.scss'],
})
export class FlowerNameSampleComponent implements OnInit {
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}
}
